import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiInnerWrapComponent } from '@qai/ui';
import { IUserTranscriptResponse } from 'src/app/interfaces/iuser-transcript-response';

@Component({
  selector: 'app-result-call-transcript',
  imports: [TranslocoModule, QaiInnerWrapComponent],
  templateUrl: './result-call-transcript.component.html',
  styleUrl: './result-call-transcript.component.scss',
})
export class ResultCallTranscriptComponent {
  @Input() transcriptResponse: IUserTranscriptResponse | undefined = undefined;

  get transformedTranscript(): string {
    if (!this.transcriptResponse) return '';

    const { userTranscript, agentName, userName } = this.transcriptResponse;
    let isFirstAgentSays = true;

    return userTranscript
      .replace(/\n/g, '')
      .replace(/(agentSays: |userSays: )/g, (match) => {
        if (match === 'agentSays: ' && isFirstAgentSays) {
          isFirstAgentSays = false;
          return `<span class='name'>${agentName}:</span> `;
        } else if (match === 'agentSays: ') {
          return `<br><br><span class='name'>${agentName}:</span> `;
        } else {
          return `<br><br><span class='name'>${userName}:</span> `;
        }
      });
  }
}
